import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { SplitterManagementPage } from '@/features/devices'

export const Route = createFileRoute('/_authenticated/devices/splitters')({
  component: () => (
    <RequirePermission permission='splitters.read'>
      <SplitterManagementPage />
    </RequirePermission>
  ),
})
